// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'bank-transaction.page.title': 'Transactions',
    'bank-transaction.page.search_results': 'Search Results',
    'bank-transaction.page.create.title': 'Create New Transaction',
    'bank-transaction.page.search.title': 'Find Transactions',
    'bank-transaction.page.money-in.title': 'Money In',
    'bank-transaction.page.money-out.title': 'Money Out',
    'bank-transaction.page.internal-transfer.title': 'Transfer Funds',
    'bank-transaction.page.transfer.title': 'Bank Transfer',
    'bank-transaction.page.reconciliation.title': 'Bank Reconciliation',
    'bank-transaction.page.auto-reconciliation.title': 'Auto Bank Reconciliation',
    'bank-transaction.page.outstanding.title': 'Outstanding Transactions',
    'bank-transaction.page.title.deposit_funds': 'Deposit Funds',
    'bank-transaction.page.view.title': 'View Transaction',
    'bank-transaction.page.all': 'All',

    'bank-transaction.button.cancel': 'Cancel',
    'bank-transaction.button.select': 'Select',
    'bank-transaction.button.find': 'Find Transactions',
    'bank-transaction.button.search': 'Apply',
    'bank-transaction.button.reconcile': 'Reconcile',
    'bank-transaction.button.new': 'New Transaction',
    'bank-transaction.button.save': 'Save Changes',
    'bank-transaction.button.transfer': 'Transfer',
    'bank-transaction.button.delete': 'Permanently Delete',
    'bank-transaction.button.edit': 'Edit',
    'bank-transaction.button.restore': 'Restore',
    'bank-transaction.button.deposit': 'Deposit',
    'bank-transaction.button.reset': 'Reset',
    'bank-transaction.button.rollback': 'Rollback Transaction',
    'bank-transaction.button.auto_match': 'Auto Match',
    'bank-transaction.button.process_selected': 'Approve Selected',
    'bank-transaction.button.manual_match': 'Match',
    'bank-transaction.button.split': 'Split',
    'bank-transaction.button.create_new': 'Create New',
    'bank-transaction.button.create': 'Create',
    'bank-transaction.button.unmatch': 'Unmatch',
    'bank-transaction.button.create_match': 'Create Match',
    'bank-transaction.button.split_transaction': 'Split Transaction',
    'bank-transaction.button.add_split_item': 'Add Split Item',
    'bank-transaction.button.clear_skipped': 'Clear Skipped',
    'bank-transaction.button.clearing_skipped': 'Clearing...',

    'bank-transaction.placeholder.search': 'Search transactions',
    'bank-transaction.placeholder.split_description': 'Enter description for this split',
    'bank-transaction.placeholder.split_amount': 'Enter amount',
    'bank-transaction.placeholder.reference': 'Reference (optional)',

    'bank-transaction.link.create_first_bank_transaction': 'Click here to create your first bank transaction',
    'bank-transaction.link.bank_transactions': ' Return to Transactions',
    'bank-transaction.link.retry': 'Click here to retry',
    'bank-transaction.link.deposit_funds': 'Deposit Funds',
    'bank-transaction.link.view_source_transaction': 'View Source Transaction',

    'bank-transaction.checkbox.all': 'Check All',
    'bank-transaction.checkbox.actions_label': 'with selected',

    'bank-transaction.label.bank_account': 'Account',
    'bank-transaction.label.from_bank_account': 'From Account',
    'bank-transaction.label.to_bank_account': 'To Account',
    'bank-transaction.label.transaction_amount': 'Amount',
    'bank-transaction.label.account_name': 'Bank Account',
    'bank-transaction.label.bank_transaction_type_name': 'Transaction Type',
    'bank-transaction.label.transaction_date': 'Transaction Date',
    'bank-transaction.label.from_transaction_date': 'From Transaction Date',
    'bank-transaction.label.to_transaction_date': 'To Transaction Date',
    'bank-transaction.label.date_posted': 'Date Posted',
    'bank-transaction.label.reconciled_on': 'Reconciled On',
    'bank-transaction.label.cancelled_on': 'Cancelled On',
    'bank-transaction.label.deposited_on': 'Deposited On',
    'bank-transaction.label.description': 'Description',
    'bank-transaction.label.description_filter': 'Description filter',
    'bank-transaction.label.entity_name': 'Contact',
    'bank-transaction.label.payment_method_name': 'Payment Method',
    'bank-transaction.label.reference_code': 'Reference Code',
    'bank-transaction.label.reference': 'Reference',
    'bank-transaction.label.memo': 'Memo',
    'bank-transaction.label.is_bundled': 'Is Bundled',
    'bank-transaction.label.currency_name': 'Currency',
    'bank-transaction.label.transaction_amount_in_cents': 'Amount',
    'bank-transaction.label.from_transaction_amount': 'From Amount',
    'bank-transaction.label.to_transaction_amount': 'To Amount',
    'bank-transaction.label.currency_amount_in_cents': 'Amount',
    'bank-transaction.label.is_reconciled': 'Is Reconciled',
    'bank-transaction.label.is_cancelled': 'Is Cancelled',
    'bank-transaction.label.cancellation_reason': 'Cancellation Reason',
    'bank-transaction.label.current_transaction': 'Current Transaction',
    'bank-transaction.label.headoffice_transactions': 'HeadOffice Transactions',
    'bank-transaction.label.transactions': 'Transactions',
    'bank-transaction.label.general_ledger_account': 'Account',
    'bank-transaction.label.total_matches': 'Total Matches',
    'bank-transaction.label.match_rate': '100% match rate',
    'bank-transaction.label.unmatched_local': 'Unmatched Local',
    'bank-transaction.label.unmatched_bank': 'Unmatched Bank',
    'bank-transaction.label.difference': 'Difference',
    'bank-transaction.label.surplus': 'Surplus',
    'bank-transaction.label.deficit': 'Deficit',
    'bank-transaction.label.of_total': 'of {total} total',
    'bank-transaction.label.date': 'Date',
    'bank-transaction.label.amount': 'Amount',
    'bank-transaction.label.auto_matched': 'Auto Matched',
    'bank-transaction.label.calculating': 'Calculating...',
    'bank-transaction.label.select_all': 'Select All',
    'bank-transaction.label.of': 'of',
    'bank-transaction.label.selected': 'selected',
    'bank-transaction.label.transaction_match': 'Transaction Match',
    'bank-transaction.label.local_transaction': 'Local Transaction',
    'bank-transaction.label.bank_transaction': 'Bank Transaction',
    'bank-transaction.label.differences_found': 'Differences Found',
    'bank-transaction.label.score_breakdown': 'Score Breakdown',
    'bank-transaction.label.unmatched_local_transactions': 'Unmatched Local Transactions',
    'bank-transaction.label.unmatched_bank_transactions': 'Unmatched Bank Transactions',
    'bank-transaction.label.date_range': 'Date Range',
    'bank-transaction.label.amount_range': 'Amount Range',
    'bank-transaction.label.from': 'From',
    'bank-transaction.label.to': 'To',
    'bank-transaction.label.min': 'Min',
    'bank-transaction.label.max': 'Max',
    'bank-transaction.label.search_description': 'Search Description',
    'bank-transaction.label.search_transactions': 'Search Transactions',
    'bank-transaction.label.actions': 'Actions',
    'bank-transaction.label.match_quality': 'Match Quality',
    'bank-transaction.label.match_details': 'Match Details',
    'bank-transaction.label.amount_difference': 'Amount Difference',
    'bank-transaction.label.date_difference': 'Date Difference',
    'bank-transaction.label.days': 'days',
    'bank-transaction.label.split_summary': 'Split Summary',
    'bank-transaction.label.original_amount': 'Original Amount',
    'bank-transaction.label.split_total': 'Split Total',

    'bank-transaction.tab.suggested_matches': 'Suggested Matches',
    'bank-transaction.tab.unmatched_local': 'Unmatched Local',
    'bank-transaction.tab.unmatched_bank': 'Unmatched Bank',
    'bank-transaction.tab.expense': 'Expense',
    'bank-transaction.tab.money_in': 'Money In',
    'bank-transaction.tab.money_out': 'Money Out',
    'bank-transaction.tab.matched': 'Matched',

    'bank-transaction.match_type.exact': 'Exact',
    'bank-transaction.match_type.amount': 'Amount',
    'bank-transaction.match_type.date': 'Date',
    'bank-transaction.match_type.description': 'Description',
    'bank-transaction.match_type.manual': 'Manual',

    'bank-transaction.dialog.manual_match.title': 'Manual Match Transaction',
    'bank-transaction.dialog.manual_match.selected_transaction': 'Selected Transaction',
    'bank-transaction.dialog.manual_match.potential_matches': 'Potential Matches',
    'bank-transaction.dialog.split_transaction.title': 'Split Transaction',
    'bank-transaction.dialog.split_transaction.original_transaction': 'Original Transaction',
    'bank-transaction.dialog.split_transaction.instructions_title': 'How to Split',
    'bank-transaction.dialog.split_transaction.instructions_text': 'Break down this transaction into multiple smaller transactions. The total of all split amounts must equal the original transaction amount.',
    'bank-transaction.dialog.split_transaction.split_items': 'Split Items',
    'bank-transaction.dialog.create_from_bank.title': 'Create Transaction from Bank Import',
    'bank-transaction.dialog.create_expense.title': 'Create Expense from Bank Transaction',
    'bank-transaction.dialog.create_expense.bank_transaction': 'Bank Transaction',
    'bank-transaction.dialog.create_expense.create_draft': 'Create Draft Expense',
    'bank-transaction.dialog.create_expense.success': 'Draft expense has been created successfully',
    'bank-transaction.dialog.create_expense.error': 'Failed to create expense. Please try again.',
    'bank-transaction.dialog.create_money_in.success': 'Money in transaction recorded successfully',
    'bank-transaction.dialog.create_money_in.error': 'Failed to record money in. Please try again.',
    'bank-transaction.dialog.create_money_out.success': 'Money out transaction recorded successfully',
    'bank-transaction.dialog.create_money_out.error': 'Failed to record money out. Please try again.',

    'bank-transaction.message.date_range': 'Select date range for transactions to reconcile',
    'bank-transaction.message.search_transaction': 'Search for matching transactions',
    'bank-transaction.message.no_match': 'No matching transactions found',
    'bank-transaction.message.no_transactions': 'No outstanding transactions found',
    'bank-transaction.message.nothing_to_reconcile': 'No transactions found to reconcile',
    'bank-transaction.message.review': 'Please review t',
    'bank-transaction.message.match_transactions_found': 'Match Transactions Found',
    'bank-transaction.message.loading_matches': 'Loading suggested matches...',
    'bank-transaction.message.loading_transactions': 'Loading transactions...',
    'bank-transaction.message.no_suggested_matches': 'No suggested matches found',
    'bank-transaction.message.no_suggested_matches_description': 'All transactions have been matched or none are eligible for auto-matching.',
    'bank-transaction.message.no_matched_transactions': 'No matched transactions',
    'bank-transaction.message.all_matched_description': 'Matched transactions will appear here after auto-matching or manual matching.',
    'bank-transaction.message.no_unmatched_transactions': 'No unmatched transactions',
    'bank-transaction.message.all_local_transactions_matched': 'All local transactions have been matched',
    'bank-transaction.message.all_bank_transactions_matched': 'All bank transactions have been matched',
    'bank-transaction.message.no_potential_matches': 'No potential matches found',
    'bank-transaction.message.try_adjusting_search': 'Try adjusting your search criteria',
    'bank-transaction.message.amount_difference': 'Amount differs by {difference}',
    'bank-transaction.message.date_difference': 'Dates differ by {days} days',
    'bank-transaction.message.description_significantly_different': 'Description significantly different',
    'bank-transaction.message.split_amounts_must_equal_original': 'Split amounts must equal the original transaction amount',
    'bank-transaction.message.reconciliation_completed': 'Reconciliation completed for {name}',
    'bank-transaction.message.no_skipped_transactions': 'No skipped transactions found.',

    'bank-transaction.error.description_required': 'Description is required',
    'bank-transaction.error.amount_required': 'Amount is required and must be greater than 0',
    'bank-transaction.error.split_total_mismatch': 'Split total must equal original amount',

    'bank-transaction.success.auto_match_started': 'Auto matching started. You will receive an email when completed.',
    'bank-transaction.success.match_approved': 'Match has been approved',
    'bank-transaction.success.match_rejected': 'Match has been rejected',
    'bank-transaction.success.bulk_matches_processed': 'Selected matches have been processed',
    'bank-transaction.success.manual_match_created': 'Manual match has been created',
    'bank-transaction.success.transaction_split': 'Transaction has been split successfully',
    'bank-transaction.success.unmatched': 'Transaction has been unmatched',

    'bank-transaction.sort.field_label': 'Field',
    'bank-transaction.sort.direction_label': 'Direction',
    'bank-transaction.sort.direction_ascending': 'Ascending',
    'bank-transaction.sort.direction_descending': 'Descending',

    'bank-transaction.modal.title.bank_transaction_delete_permanently': 'Delete Bank Transaction',
    'bank-transaction.modal.title.bank_transaction_restore': 'Restore Bank Transaction',
    'bank-transaction.modal.title.bank_transaction_rollback': 'Rollback Bank Transaction',

    'bank-transaction.modal.message.bank_transaction_delete_permanently':
        'Are you sure that you want to permanently delete this bank transaction? This action cannot be undone. | Are you sure that you want to permanently delete these bank transactions? This action cannot be undone.',
    'bank-transaction.modal.message.bank_transaction_restore': 'Are you sure that you want to restore this bank transaction? | Are you sure that you want to restore these bank transactions?',
    'bank-transaction.modal.message.bank_transaction_rollback': 'Are you sure that you want to rollback this transaction?',

    'bank-transaction.success.message.bank_transaction_created': 'Your bank transaction has been created',
    'bank-transaction.success.message.bank_transaction_updated': 'Your bank transaction has been updated',
    'bank-transaction.success.message.bank_transaction_reconciled': 'Transactions have been reconciled.',
    'bank-transaction.success.message.bank_transactions_reconciled': 'Congratulations, your transactions have been reconciled.',
    'bank-transaction.success.message.funds_deposited': 'Funds have been deposited.',
    'bank-transaction.success.message.bank_transaction_rolled_back': 'Your bank transaction has been rolled back.',
    'bank-transaction.success.message.bank_transaction_skipped': 'Bank transaction has been successfully skipped.',
    'bank-transaction.success.message.skipped_transactions_cleared':
        '{count} skipped transaction has been cleared and is now available for reconciliation. | {count} skipped transactions have been cleared and are now available for reconciliation.',

    'bank-transaction.error.message.bank_transaction_deleted': 'This bank transaction was already permanently deleted | These bank transactions were already permanently deleted',
    'bank-transaction.error.message.bank_transaction_restored': 'This bank transaction was already restored | These bank transactions were already restored',
    'bank-transaction.error.message.bank_transaction_rolled_back': 'This bank transaction was already rolled back.',
    'bank-transaction.error.message.error_loading_page': 'Sorry, there was an error loading bank transaction.| Sorry, there was an error loading bank transactions.',

    'button.filters': 'Filters',
    'button.apply_filters': 'Apply Filters',
    'button.export': 'Export',
    'button.cancel': 'Cancel',
    'button.approve': 'Approve',
    'button.reject': 'Reject',
    'button.show_details': 'Show Details',
    'button.hide_details': 'Hide Details',
    'button.view_full_details': 'View Full Details',
    'button.advanced_search': 'Advanced Search',
    'button.search': 'Search',
};
